import React from 'react';
import { Sun, Moon } from 'lucide-react';
import useTimeAgo from '../hooks/useTimeAgo';

const Header = ({ startDate, currentDate, repoCount, onRefresh, lastUpdated, onToggleTheme, isDark, selectedDate, maxDate, onDateChange }) => {
  const lastUpdatedLabel = useTimeAgo(lastUpdated);
  return (
    <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-800 sticky top-0 z-20">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">
            Trending GitHub Repos
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Created in the last 10 days • {startDate} — {currentDate}
              {typeof repoCount === 'number' && (
                <span className="ml-3 font-medium text-gray-700 dark:text-gray-300">Showing {repoCount}</span>
              )}
              {lastUpdated && (
                <span className="ml-3 text-sm text-gray-500 dark:text-gray-400">Last updated {lastUpdatedLabel} ago</span>
              )}
          </p>
        </div>

        <div className="flex items-center gap-3">
          <label className="flex items-center gap-2">
            <span className="sr-only">Select current date</span>
            <input
              type="date"
              value={selectedDate}
              max={maxDate}
              onChange={(e) => onDateChange(e.target.value)}
              className="text-sm px-2 py-1 border rounded-md"
            />
          </label>
          <button
            onClick={onRefresh}
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label="Refresh repositories"
          >
            Refresh
          </button>

          <button
            onClick={onToggleTheme}
            className="p-2 rounded-md bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none"
            aria-label="Toggle theme"
            aria-pressed={isDark}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDark ? <Moon size={16} className="text-gray-200" /> : <Sun size={16} className="text-gray-600" />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;